import { api } from "./api";
import type { Expense, ExpenseCategory, ExpenseMethod } from "@/types/models";

interface PaginatedResponse<T> {
  data: T[];
  meta: { total: number; limit: number; offset: number };
}

export const expenseCategoryService = {
  list: () =>
    api.get<ExpenseCategory[]>("/expense-categories").then((r) => r.data),
  create: (data: { name: string; is_wages?: boolean }) =>
    api
      .post<ExpenseCategory>("/expense-categories", data)
      .then((r) => r.data),
  update: (
    id: number,
    data: { name: string; active: boolean; is_wages?: boolean },
  ) =>
    api.put(`/expense-categories/${id}`, data).then((r) => r.data),
};

export const expenseService = {
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse<Expense>>("/expenses", { params })
      .then((r) => r.data),
  get: (id: number) =>
    api.get<Expense>(`/expenses/${id}`).then((r) => r.data),
  create: (data: {
    date: string;
    category_id: number;
    amount: number;
    method?: ExpenseMethod;
    invoice_number?: string;
    description?: string;
    party_name?: string;
    notes?: string;
    attachment_ids?: number[];
  }) => api.post<Expense>("/expenses", data).then((r) => r.data),
  update: (id: number, data: {
    date: string;
    category_id: number;
    amount: number;
    method?: ExpenseMethod;
    invoice_number?: string;
    description?: string;
    party_name?: string;
    notes?: string;
    attachment_ids?: number[];
  }) => api.put<Expense>(`/expenses/${id}`, data).then((r) => r.data),
  delete: (id: number) =>
    api.delete(`/expenses/${id}`).then((r) => r.data),
};
